import history from '../../util/history'

const toAccountTitleEditView = async titleId => {
  titleId ? history.push(`/account_titles/${titleId}/edit`) : history.push(`/account_titles/new`)
  return true
}

export default toAccountTitleEditView
